import React from 'react'

export default class IconsEdit extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className={className}
                style={this.props.style}
            >
                <g clipPath='url(#clip0_3728_21886)'>
                    <path
                        d='M4 1.33301V10.6663C4 11.02 4.14048 11.3591 4.39052 11.6092C4.64057 11.8592 4.97971 11.9997 5.33333 11.9997H14.6667'
                        stroke={color}
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M12.0002 14.6667V5.33333C12.0002 4.97971 11.8597 4.64057 11.6096 4.39052C11.3596 4.14048 11.0205 4 10.6668 4H1.3335'
                        stroke={color}
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_3728_21886'>
                        <rect width='16' height='16' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
}
